import { useEffect, useMemo, useState } from "react"
import { Link } from "react-router-dom"
import { Input, Button, Table, Space, Select, TreeSelect } from 'antd'
import { SearchOutlined, RedoOutlined } from '@ant-design/icons'
import { axiosTable, baseAxiosNoInfo } from "../../tool/axios"
import BreadCrumb from '../../component/BreadCrumb'
import { DeleteButton } from "../../component/common/Buttons"
import getPermission from '../../js/permission'
import _ from 'lodash'

const { Option } = Select
const { Column } = Table

type fetchParams = {
    user_name: string | undefined,
    phone: string | undefined,
    employee_num: string | undefined,
    department_id: string | undefined,
    position_id: string | undefined,
    status: undefined,
    is_sys_user: 0 | 1 | undefined
}

type pagination = {
    current: number,
    pageSize: number,
    total: number,
    showSizeChanger: boolean
}

export default function PersonnelMange() {

    let fetchOtherParamsTmpl = {
        user_name: undefined,
        phone: undefined,
        employee_num: undefined,
        department_id: undefined,
        position_id: undefined,
        status: undefined,
        is_sys_user: undefined
    }

    const [fetchOtherParams, setFetchOtherParams] = useState<fetchParams>(fetchOtherParamsTmpl)
    const [pagination, setPagination] = useState<pagination>({
        current: 1,
        pageSize: 8,
        total: 0,
        showSizeChanger: true
    })

    // 列表数据
    const [data, setData] = useState<any>([])

    const [options, setOption] = useState<any[]>([])
    const [positionOptions, setPositionOptions] = useState<any>([])

    const permission: string[] = useMemo(() => {
        return getPermission()
    }, [window.location.pathname])

    useEffect(() => {
        // 查询部门
        baseAxiosNoInfo('/manpower_center/department/tree_list').then((res: any) => {
            if (res) setOption(res)
        })

        // 查询职位
        baseAxiosNoInfo('/global/position_list').then((res: any) => {
            if (res) setPositionOptions(res)
        })
    }, [])

    useEffect(() => {
        fetch({ pagination, fetchOtherParams })
    }, [pagination.current, pagination.pageSize])

    const handleInputChange = (value: any, attr: string) => {
        let params: any = _.cloneDeep(fetchOtherParams)
        params[attr] = value

        setFetchOtherParams(params)
    }

    const handleSearch = () => {
        const p = { ...pagination }
        p.current = 1

        fetch({ pagination: p, fetchOtherParams })
    }

    const handleTableChange = (antPagination: any) => {
        const p = { ...pagination }
        p.current = antPagination.current
        p.pageSize = antPagination.pageSize

        setPagination(p)
    }

    const fetch = ({ pagination, fetchOtherParams }: { pagination: Object, fetchOtherParams: object }) => {
        let iPagination: any = { ...pagination }
        iPagination.page_num = iPagination.current
        iPagination.page_size = iPagination.pageSize

        delete iPagination.current
        delete iPagination.pageSize
        delete iPagination.total

        axiosTable.get('/manpower_center/employee/page_list', {
            params: {
                ...iPagination,
                ...fetchOtherParams

            }
        }).then((response: any) => {
            let p: any = { ...pagination }
            p.total = response.total

            setPagination(p)
            setData(response.records)
        })
    }

    const resetForm = () => {
        setFetchOtherParams(fetchOtherParamsTmpl)

        let p: any = { ...pagination }
        p.current = 1

        setPagination(p)
        fetch({ pagination: p, fetchOtherParams: fetchOtherParamsTmpl })
    }

    const recursionChildren = (children: any[]) => {
        let childArr: any = []

        children.forEach((el: any) => {
            childArr.push({
                title: el.department_name,
                value: el.department_id,
                key: el.department_id,
                children: el.children && recursionChildren(el.children)
            })
        })

        return childArr
    }

    return (<div className="common-page">
        {/* 人力中心 -> 员工及角色 -> 员工管理 */}
        <BreadCrumb position={['人力中心', '员工管理']} />

        <div className="common-top-form">
            <Space direction="horizontal" wrap>
                <Input style={{ marginRight: 8, marginBottom: 12, width: '120px' }} placeholder="员工工号" onChange={(e: { target: { value: string } }) => { handleInputChange(e.target.value, 'employee_num') }} value={fetchOtherParams.employee_num} />
                <Input style={{ marginRight: 8, marginBottom: 12, width: '120px' }} placeholder="员工姓名" onChange={(e: { target: { value: string } }) => { handleInputChange(e.target.value, 'user_name') }} value={fetchOtherParams.user_name} />
                <Input style={{ marginRight: 8, marginBottom: 12, width: '120px' }} placeholder="员工手机号" onChange={(e: { target: { value: string } }) => { handleInputChange(e.target.value, 'phone') }} value={fetchOtherParams.phone} />

                <TreeSelect style={{ marginRight: 8, marginBottom: 12, width: '200px' }} value={fetchOtherParams.department_id} virtual={true} treeData={recursionChildren(options)} placeholder="员工组织" showSearch allowClear
                    onChange={(v: any) => { handleInputChange(v, 'department_id') }}
                    filterTreeNode={(inputValue: any, treeNode: any) => (treeNode.title.indexOf(inputValue) != -1)}
                />
                <Select style={{ marginRight: 8, marginBottom: 12, width: '150px' }} placeholder="员工职位" showSearch allowClear onChange={(e: any) => { handleInputChange(e, 'position_id') }} value={fetchOtherParams.position_id}
                    filterOption={(input, option) => (option!.children as unknown as string).includes(input)}
                >
                    {positionOptions.map((el: any) => (<Option value={el.position_id} key={el.position_id}>{el.position_name}</Option>))}
                </Select>

                <Select style={{ marginRight: 8, marginBottom: 12, width: '100px' }} placeholder="员工状态" allowClear onChange={(e: number) => { handleInputChange(e, 'status') }} value={fetchOtherParams.status} >
                    <Option value={1} key="1">在职</Option>
                    <Option value={2} key="2">离职</Option>
                </Select>
                <Select style={{ marginRight: 8, marginBottom: 12, width: '130px' }} placeholder="是否系统用户" allowClear onChange={(e: number) => { handleInputChange(e, 'is_sys_user') }} value={fetchOtherParams.is_sys_user} >
                    <Option value={1} key="1">是</Option>
                    <Option value={0} key="0">否</Option>
                </Select>
            </Space>

            <div style={{ marginTop: 10 }}>
                <Button style={{ marginRight: 12, marginBottom: 12 }} className="search-btn" icon={<SearchOutlined />} onClick={handleSearch}>查询</Button>
                <Button style={{ marginRight: 12, marginBottom: 12 }} onClick={resetForm} icon={<RedoOutlined />}>重置</Button>
                <Button style={{ marginRight: 12, marginBottom: 12 }} type="primary" ><Link to={"/personnel_manage_add"}>添加</Link></Button>
            </div>
        </div>

        <div className="common-main">
            <Table dataSource={data} scroll={{ x: 'max-content' }} bordered={true} rowKey="id" pagination={pagination} onChange={handleTableChange}>
                <Column title="员工工号" dataIndex="employee_num" key="employee_num" />
                <Column title="员工姓名" dataIndex="user_name" key="user_name" />
                <Column title="员工手机号" dataIndex="phone" key="phone" />
                <Column title="员工组织职位" dataIndex="department_position_arr" key="department_position_arr" render={(v: string[]) => {
                    return v.map(el => <p>{el}</p>)
                }} />
                <Column title="员工状态" dataIndex="status" key="status" render={(status: number) => {
                    let str: string = ''
                    switch (status) {
                        case 1:
                            str = '在职'
                            break;
                        case 2:
                            str = '离职'
                            break;
                    }
                    return str
                }} />

                <Column title="入职日期" dataIndex="in_date" key="in_date" />
                <Column title="离职日期" dataIndex="out_date" key="out_date" />
                <Column title="是否系统用户" dataIndex="is_sys_user" key="is_sys_user" render={(status: number) => {
                    let str: string = ''
                    switch (status) {
                        case 1:
                            str = '是'
                            break;
                        case 0:
                            str = '否'
                            break;
                    }
                    return str
                }} />

                <Column
                    title="操作"
                    key="action"
                    render={(text, record: any) => (
                        <Space size="middle">
                            <Button size="small" type="primary" ><Link to={"/personnel_manage_edit/" + record.id}>查看</Link></Button>
                            {permission.includes('删除') && <DeleteButton url="/manpower_center/employee/delete" record={record} cb={resetForm}>删除</DeleteButton>}
                        </Space>
                    )}
                />
            </Table>
        </div>
    </div>)
}